export default {
  name: 'LinkButton'
};